module.exports = __webpack_public_path__ + "media/images/item/btn_rumor_ov-a5257294d5287dc75cb48258560e2c84.png";